<template lang="html">
  <section class="text-legal pad-sec -avisoLegal" v-html="$t('aviso_legal')">
  </section>
</template>

<script lang="js">
export default {
  name: 'aviso-legal'
}
</script>


// WEBPACK FOOTER //
// src/components/views/aviso-legal.vue